import { useFormContext } from 'react-hook-form';

import { Switch } from '@quick/components/Switch';

import { useAppTranslation } from '@/app/i18n/client';

import type { IForm } from '../types';

export function RoundTrip() {
  const { watch, setValue } = useFormContext<IForm>();
  const { t } = useAppTranslation(['common', 'demand']);
  const roundTrip = watch('round_trip');
  const toggleRoundTrip = () => setValue('round_trip', !roundTrip);

  return (
    <Switch
      id="flexCheckDefault"
      checked={roundTrip || false}
      handleChange={toggleRoundTrip}
      text={t('demand:addresses.checkbox')}
      className="items-center font-medium"
    />
  );
}
